import { useAtomValue } from "jotai";
import { userData } from "../state";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const user = useAtomValue(userData);

  if (user?.access_token) {
    return <Outlet />;
  }

  return <Navigate to="/overview" replace />;
};

export default ProtectedRoute;
